import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import RequirementsSection from './sections/RequirementsSection';
import RequirementDetail from './pages/RequirementDetail';
import RequirementCreate from './pages/RequirementCreate';

interface IProps {}

const Requirements: React.FC<IProps> = (props) => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/create/:type`} component={RequirementCreate}/>
      <Route path={`${match.path}/:requirementId`} component={RequirementDetail}/>
      <Route path={match.path}>
        <Header title={t("requirements.title")} includeBreadcrumbs />
        <ModuleContent>
          <RequirementsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default Requirements;